function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#3E3852",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 7.109h32M27.322 12.657L32.98 7l-5.657-5.657"
}));

function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMzUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+R3JvdXAgMiBDb3B5IDM8L3RpdGxlPgogICAgPGcgaWQ9IldlYnNpdGUtZWFybHktZXhwbG9yYXRpb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtMi1Db3B5LTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxLjAwMDAwMCkiIHN0cm9rZT0iIzNFMzg1MiIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8bGluZSB4MT0iMCIgeTE9IjYuMTA4NjM2MjciIHgyPSIzMiIgeTI9IjYuMTA4NjM2MjciIGlkPSJQYXRoLTYiPjwvbGluZT4KICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy4zMjI0MjAsIDYuMDAwMDAwKSByb3RhdGUoLTQ1LjAwMDAwMCkgdHJhbnNsYXRlKC0yNy4zMjI0MjAsIC02LjAwMDAwMCkgIiBwb2ludHM9IjIzLjMyMjQxOTUgMTAgMzEuMzIyNDE5NSAxMCAzMS4zMjI0MTk1IDIiPjwvcG9seWxpbmU+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgRightArrow as ReactComponent };